export default [
  {
    key: '',
    value: 'Choose transaction type',
  },
  {
    key: 'CUSTOMER_INSTALLMENT_PAYMENT',
    value: 'CUSTOMER_INSTALLMENT_PAYMENT',
  },
  {
    key: 'BANK_INSTALLMENT_PAYMENT',
    value: 'BANK_INSTALLMENT_PAYMENT',
  },
  {
    key: 'CUSTOMER_INSTALLMENT_REFUND',
    value: 'CUSTOMER_INSTALLMENT_REFUND',
  },
  {
    key: 'BANK_INSTALLMENT_REFUND',
    value: 'BANK_INSTALLMENT_REFUND',
  },
  {
    key: 'CUSTOMER_INSTALLMENT_PARTIAL_REFUND',
    value: 'CUSTOMER_INSTALLMENT_PARTIAL_REFUND',
  },
  {
    key: 'BANK_INSTALLMENT_PARTIAL_REFUND',
    value: 'BANK_INSTALLMENT_PARTIAL_REFUND',
  },
  {
    key: 'ORDER_CASHEW_FEE',
    value: 'ORDER_CASHEW_FEE',
  },
  {
    key: 'PAYMENT_GATEWAY_TRANSACTION_FEE',
    value: 'PAYMENT_GATEWAY_TRANSACTION_FEE',
  },
  {
    key: 'CASHEW_LATE_PAYMENT_FEE',
    value: 'CASHEW_LATE_PAYMENT_FEE',
  },
  {
    key: 'MERCHANT_ORDER_FULL_PAYMENT',
    value: 'MERCHANT_ORDER_FULL_PAYMENT',
  },
  {
    key: 'MERCHANT_ORDER_FULL_REFUND',
    value: 'MERCHANT_ORDER_FULL_REFUND',
  },
  {
    key: 'MERCHANT_ORDER_PARTIAL_REFUND',
    value: 'MERCHANT_ORDER_PARTIAL_REFUND',
  },
  {
    key: 'CUSTOMER_ORDER_PAYMENT',
    value: 'CUSTOMER_ORDER_PAYMENT',
  },
  {
    key: 'BANK_ORDER_PAYMENT',
    value: 'BANK_ORDER_PAYMENT',
  },
  {
    key: 'BANK_ORDER_REFUND',
    value: 'BANK_ORDER_REFUND',
  },
  {
    key: 'CUSTOMER_ORDER_REFUND',
    value: 'CUSTOMER_ORDER_REFUND',
  },
  {
    key: 'BANK_ORDER_PARTIAL_REFUND',
    value: 'BANK_ORDER_PARTIAL_REFUND',
  },
  {
    key: 'CUSTOMER_ORDER_PARTIAL_REFUND',
    value: 'CUSTOMER_ORDER_PARTIAL_REFUND',
  },
];
